export default __webpack_public_path__ + "static/media/logo.0a9cf844.gif";